/**
 * Knockout tab body for the League Detail page. Renders the data-driven bracket from the
 * schedule's knockout fixtures, or — for a national-team group tournament whose draw hasn't
 * been synced yet — a provisional projection.
 */

import React, { useMemo } from 'react'
import { KnockoutBracket } from '../../knockout/KnockoutBracket'
import { buildLeagueKnockoutBracket } from '../../../src/leagueDetail/helpers/buildLeagueKnockoutBracket.helper'
import { buildProvisionalWorldCupBracket } from '../../../src/worldcup/helpers/buildProvisionalWorldCupBracket.helper'
import type { LeagueFixture } from '../../../src/leagueDetail/helpers/leagueFixtureSections.helper'

interface LeagueKnockoutTabProps {
  matches: LeagueFixture[]
  /** True when no real knockout fixtures exist yet — show the provisional projection instead. */
  provisional: boolean
}

export const LeagueKnockoutTab: React.FC<LeagueKnockoutTabProps> = ({ matches, provisional }) => {
  const real = useMemo(() => buildLeagueKnockoutBracket(matches), [matches])
  const projection = useMemo(() => (provisional ? buildProvisionalWorldCupBracket() : null), [provisional])

  if (projection != null) {
    return <KnockoutBracket model={projection} testID="league-detail-knockout-provisional" />
  }

  return <KnockoutBracket model={real} testID="league-detail-knockout" />
}
